<template>
    <div class="flex flex-col h-full w-full">
        <p class="text-xs text-gray-500 mb-1 shrink-0">
            Copy a field into your template. Optionally steer the LLM inline, e.g.
            <span class="font-mono bg-gray-100 px-1 rounded">[PRODUCTS - focus on landing gear, ignore coatings]</span>
        </p>
        <!-- QuickSearchList snapshots its rows prop at setup and never re-reads it,
             so it must not mount until the async fetch has populated `rows`. -->
        <QuickSearchList
            v-if="loaded"
            class="border bg-white border-gray-300 rounded-md w-full flex-1 min-h-0"
            :rows="rows"
        />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import QuickSearchList from '../base-components/QuickSearchList.vue';
import { getLlmInterpretationFields } from '@/services/EmailTemplates';

const store = useStore();
const rows = ref({});
const loaded = ref(false);

onMounted(async () => {
    try {
        const fields = await getLlmInterpretationFields(store.state.auth.token);
        const built = {};
        (fields || []).forEach((field, index) => {
            built[`interpretation_${index}`] = {
                name: field.token,
                label: `${field.label} — sources: ${(field.source_fields || []).join(', ')}`,
                value: field.token,
                visible: true,
                copy: true,
            };
        });
        rows.value = built;
    } catch (e) {
        rows.value = {};
    } finally {
        loaded.value = true;
    }
});
</script>
